import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";

/**
 * Наценка с возможностью выставить null.
 *
 * null != 0: при null наценка не применяется вовсе и для PTC клиент получает
 * себестоимость доставки из ptc-directions-service, при 0 — базовую цену с
 * наценкой перевозчика.
 */
const MarginField = ({ value, onChange, label = "Маржа" }) => {
    const isNull = value === null || value === undefined;

    return (
        <>
            <label>{label}</label>
            <InputNumber value={isNull ? null : value}
                         mode="decimal" minFractionDigits={2} maxFractionDigits={3} min={0}
                         disabled={isNull}
                         placeholder={isNull ? "не применяется" : ""}
                         onValueChange={e => onChange(e.value ?? 0)} />
            <div className="p-d-flex p-ai-center" style={{ marginTop: 6, gap: 8 }}>
                <Checkbox inputId="marginIsNull" checked={isNull}
                          onChange={e => onChange(e.checked ? null : 0)} />
                <label htmlFor="marginIsNull" style={{ marginBottom: 0 }}>
                    Без наценки (по себестоимости)
                </label>
            </div>
        </>
    );
};

export default MarginField;
